export enum MtxDatetimepickerFilterType {
  DATE,
  HOUR,
  MINUTE,
}
